// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import StarWhite from '../_raw/ui/icon_star_white.svg';
import withIconProps from '../withIconProps';

export default withIconProps(StarWhite);
